import { cloneDeep, each, has, orderBy } from 'lodash';
import { DiscountTypeEnum, OffTypeEnum } from '../enum';
import { toFixed } from '../lib/utils';
/**
 * 分摊算法
 * @param opt
 */
export default function upsertItemApportion(opt) {
    const { products, itemMap, orderPrice, allOff, offTip, offId, offType, discountType } = opt;
    if (allOff <= 0) {
        return;
    }
    let surplusOff = allOff;
    let allProductOff = 0;
    const canApprotionProducts = [];
    each(products, (product) => {
        var _a;
        const id = product.pk || product.productNo + '_' + product.scaleNo;
        const item = itemMap[id];
        let productPrice = 0;
        if (!has(product, 'productAndModifierPrice')) {
            product.productAndModifierPrice = product.price + (product.modifierPrice || 0);
        }
        productPrice = product.productAndModifierPrice * (product.cnt || 1);
        if (product.offType !== OffTypeEnum.DesignatedItem) {
            if (has(product, 'off')) {
                productPrice = toFixed(productPrice - product.off);
            }
            else {
                productPrice = toFixed(productPrice - (((_a = item === null || item === void 0 ? void 0 : item.apportion) === null || _a === void 0 ? void 0 : _a.off) || 0) - ((item === null || item === void 0 ? void 0 : item.itemAllOff) || 0));
            }
        }
        if (productPrice > 0) {
            const cloneProduct = cloneDeep(product);
            cloneProduct.sortProductPrice = productPrice;
            canApprotionProducts.push(cloneProduct);
        }
    });
    each(orderBy(canApprotionProducts, ['sortProductPrice'], ['asc']), (product, index) => {
        var _a, _b;
        const id = product.pk || product.productNo + '_' + product.scaleNo;
        const item = itemMap[id];
        let apportionProductOff = 0;
        if (index === canApprotionProducts.length - 1) {
            apportionProductOff = toFixed(allOff - allProductOff);
        }
        else {
            let productPrice = product.productAndModifierPrice * (product.cnt || 1);
            if (product.offType !== OffTypeEnum.DesignatedItem) {
                if (has(product, 'off')) {
                    productPrice = toFixed(productPrice - product.off);
                }
                else {
                    productPrice = toFixed(productPrice - (((_a = item === null || item === void 0 ? void 0 : item.apportion) === null || _a === void 0 ? void 0 : _a.off) || 0) - ((item === null || item === void 0 ? void 0 : item.itemAllOff) || 0));
                }
            }
            if (productPrice <= 0) {
                return;
            }
            apportionProductOff = toFixed(allOff * (productPrice / orderPrice));
            if (discountType &&
                discountType === DiscountTypeEnum.DiscountFee &&
                toFixed(productPrice - apportionProductOff) < 0.1 &&
                apportionProductOff < surplusOff) {
                apportionProductOff = productPrice;
            }
        }
        if (apportionProductOff > surplusOff) {
            apportionProductOff = surplusOff;
        }
        if (apportionProductOff <= 0) {
            return;
        }
        surplusOff = toFixed(surplusOff - apportionProductOff);
        if (item) {
            if (item.apportion) {
                item.apportion.offArr.push({ off: apportionProductOff, offId, offTip, offType });
                item.apportion.off = toFixed(apportionProductOff + (((_b = item.apportion) === null || _b === void 0 ? void 0 : _b.off) || 0));
            }
            else {
                item.apportion = {
                    off: apportionProductOff,
                    offArr: [{ off: apportionProductOff, offId, offTip, offType }],
                };
            }
        }
        else {
            itemMap[id] = {
                // items: [{ ...product, off: 0, offId: 0, offTip: '', offType: '' }],
                items: [],
                itemAllOff: 0,
                apportion: {
                    off: apportionProductOff,
                    offArr: [{ off: apportionProductOff, offId, offTip, offType }],
                },
            };
        }
        allProductOff += apportionProductOff;
    });
    return itemMap;
}
//# sourceMappingURL=upsertItemApportion.js.map